import React, { useEffect, useState, useCallback } from "react";
import "./Landing.css";
import { Link } from "react-router-dom";
import { FaLongArrowAltRight, FaUserCircle } from "react-icons/fa";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import loaderGif from "../../src/Images/loader.gif";
import { FiSearch } from "react-icons/fi";
import { basicauth, basicauthblog } from "../Utils/Credentials";
function MyLanding() {
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { password, username } = basicauthblog;
  const base64Credentials = btoa(`${username}:${password}`);
  const ITEMS_PER_PAGE = 16;
  const [currentPage, setCurrentPage] = useState(1);

  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ webid: "1" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        setCards([...data.data].reverse());
        setCurrentPage(1);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetBlogByHashtags = async (tagSlug) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetBlogByHashtags`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ hashtag: tagSlug, webid: "1" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCards(sortedData);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      if (sessionStorage.getItem("FromTag") === "1") {
        const tagSlug = JSON.parse(sessionStorage.getItem("tag"));
        await GetBlogByHashtags(tagSlug);
        sessionStorage.removeItem("FromTag");
      } else {
        await Getproductblogs();
      }
    };

    fetchData();

    return () => controller.abort();
  }, []);

  const filteredBlogs = cards.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      item.title.toLowerCase().includes(lowerSearch) ||
      item.excerpt.toLowerCase().includes(lowerSearch) ||
      item.author_name.toLowerCase().includes(lowerSearch)
    );
  });
  const chunkBlogs = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };
  const totalPages = Math.ceil(filteredBlogs.length / ITEMS_PER_PAGE);

  const paginatedBlogs = filteredBlogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const blogGroups = chunkBlogs(paginatedBlogs, 8);
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);
  const topViewedBlogs = [...cards]
    .sort((a, b) => b.views - a.views)
    .slice(0, 12);
  return (
    <section className="mb-5 pe-3">
      <h2 className="text-center">Latest Blogs </h2>
      <div className="d-flex justify-content-center m-4">
        <div style={{ position: "relative", width: "50%" }}>
          <FiSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "18px",
              transform: "translateY(-50%)",
              color: "#6c757d",
              fontSize: "1.2rem",
              pointerEvents: "none",
            }}
          />
          <input
            type="text"
            className="form-control"
            placeholder="Search by title, excerpt or author..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            style={{
              paddingLeft: "2.5rem",
              borderRadius: "50px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              height: "3rem",
            }}
          />
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
        </div>
      )}
      <div className="row p-0">
        <div className="col-9 m-0">
          <div className="row p-0">
            {blogGroups.map((group, gIndex) => (
              <React.Fragment key={gIndex}>
                <h5 className="">Featured For Member </h5>

                <div className="row mb-2">
                  <hr></hr>
                  {group[0] && (
                    <div className="col-md-6 p-1">
                      <BlogCard item={group[0]} />
                    </div>
                  )}

                  <div className="col-md-6 p-1">
                    {group[1] && (
                      <div className="mb-2">
                        <BlogCard
                          item={group[1]}
                          imageHeight="160px"
                          layout="horizontal"
                        />
                      </div>
                    )}
                    {group[2] && (
                      <BlogCard
                        item={group[2]}
                        imageHeight="160px"
                        layout="horizontal"
                      />
                    )}
                  </div>
                </div>

                <div className="row mb-2">
                  {group[3] && (
                    <div className="col-md-4 p-1">
                      <BlogCard item={group[3]} imageHeight="220px" />
                    </div>
                  )}
                  {group[4] && (
                    <div className="col-md-4 p-1">
                      <BlogCard item={group[4]} imageHeight="220px" />
                    </div>
                  )}
                  {group[5] && (
                    <div className="col-md-4 p-1">
                      <BlogCard item={group[5]} imageHeight="220px" />
                    </div>
                  )}
                </div>

                <h5 className="">Our Latest </h5>

                <div className="row mb-2">
                  <hr></hr>
                  {group[6] && (
                    <div className="col-md-6 p-1">
                      <BlogCard item={group[6]} imageHeight="260px" />
                    </div>
                  )}
                  {group[7] && (
                    <div className="col-md-6 p-1">
                      <BlogCard item={group[7]} imageHeight="260px" />
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
          {totalPages > 1 && (
            <div className="d-flex justify-content-center align-items-center mt-4">
              <button
                className="btn btn-outline-secondary me-2"
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                &lt; Prev
              </button>
              <span style={{ fontWeight: "600" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-secondary ms-2"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next &gt;
              </button>
            </div>
          )}
        </div>
        <div className="col-3 m-0 p-0">
          <h5 className="mb-0">Popular Blogs</h5>

          <div
            style={{
              position: "relative",
              width: "100%",
              height: "4px",
              backgroundColor: "#e0e0e0",
              borderRadius: "2px",
              overflow: "hidden",
              marginTop: "0.5rem",
              marginBottom: "1rem",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "30%",
                height: "100%",
                backgroundColor: "#888",
                borderRadius: "2px",
                animation: "moveBar 1.5s linear infinite",
              }}
            />
          </div>

          <style>
            {`
    @keyframes moveBar {
      0% { left: -30%; }
      100% { left: 100%; }
    }
  `}
          </style>

          {topViewedBlogs.map((ite) => (
            <SidebarBlogCard key={ite.id} item={ite} />
          ))}
        </div>
      </div>
    </section>
  );
}
const BlogCard = ({ item, imageHeight, layout = "vertical" }) => {
  const isHorizontal = layout === "horizontal";

  return (
    <div
      className="My-Landing-card"
      style={{
        backgroundColor: "#fff",
        boxShadow: "0 px 6px rgba(0,0,0,0.2)",
        borderRadius: ".4rem",
        overflow: "hidden",
      }}
    >
      {isHorizontal ? (
        <div className="row mt-2 g-0">
          <div className="col-5" style={{ overflow: "hidden" }}>
            <img
              src={item.image_url || "https://via.placeholder.com/300x200"}
              alt={item.image_alt || item.title}
              style={{
                width: "100%",
                height: "100%",
                minHeight: "160px",
                objectFit: "cover",
                objectPosition: "center",
                display: "block",
              }}
            />
          </div>

          <div className="col-7 p-2">
            <div className="d-flex align-items-center mb-1">
              <img
                src={item.author_image || ""}
                alt={item.author_name}
                className="rounded-circle"
                style={{
                  width: "26px",
                  height: "26px",
                  objectFit: "cover",
                }}
              />
              <span
                className="ms-2"
                style={{ fontSize: ".85rem", fontWeight: 600 }}
              >
                {item.author_name}
              </span>
            </div>

            <a href={`/blog/${item.slug}`} style={{ textDecoration: "none" }}>
            <h6
              style={{
                WebkitLineClamp: 2,
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                fontSize: ".95rem",   color: "#000",
              }}
            >
              {item.title}
            </h6>

            <p
              className="mb-2"
              style={{
                WebkitLineClamp: 3,
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                fontSize: ".85rem",      color: "#44444E",
              }}
            >
              {item.excerpt}
            </p>
            </a>
            <div className="text-end">
              <Link to={`/blog/${item.slug}`} style={{ fontSize: ".9rem" }}>
                Read More <FaLongArrowAltRight />
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <>
          <img
            src={item.image_url || "https://via.placeholder.com/300x200"}
            alt={item.image_alt || item.title}
            style={{
              width: "100%",
              height: imageHeight,
              objectFit: "cover",
            }}
          />

          <div style={{ padding: "12px" }}>
            <div className="d-flex align-items-center mb-2">
              <img
                src={item.author_image || ""}
                alt={item.author_name}
                className="rounded-circle"
                style={{ width: "32px", height: "32px", objectFit: "cover" }}
              />
              <span
                className="ms-2"
                style={{ fontSize: ".9rem", fontWeight: 600 }}
              >
                {item.author_name}
              </span>
            </div>
            <a href={`/blog/${item.slug}`} style={{ textDecoration: "none" }}>
            <h6
                style={{
                  WebkitLineClamp: 2,
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  fontSize: ".95rem",
                  color: "#000",
                }}
              >
                {item.title}
              </h6>

              <p
                className="mb-0"
                style={{
                  WebkitLineClamp: 3,
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  fontSize: ".9rem",
                  color: "#44444E",
                }}
              >
                {item.excerpt}
              </p>
            </a>
            <div className="text-end">
              <Link to={`/blog/${item.slug}`}>
                Read More <FaLongArrowAltRight />
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
const SidebarBlogCard = ({ item }) => {
  return (
    <div
      className="mb-3 sidebar-blog-card"
      style={{
        position: "relative",
        // borderRadius: "0.4rem",
        overflow: "hidden",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        cursor: "pointer",
      }}
    >
      <a href={`/blog/${item.slug}`} style={{ textDecoration: "none" }}>

      <img
        src={item.image_url || "https://via.placeholder.com/300x180"}
        alt={item.title}
        style={{
          width: "100%",
          height: "auto",
          display: "block",
          transition: "all 0.3s ease",
        }}
      />
      <div
        className="sidebar-blog-title"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          padding: "10px",
          color: "#fff",
          fontSize: "0.9rem",
          fontWeight: 600,
          textShadow: "1px 1px 4px rgba(0,0,0,0.8)",
          background: "rgba(0,0,0,0.3)",
          WebkitLineClamp: 2,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          transition: "all 0.3s ease",
        }}
      >
        {item.title}
      </div>
</a>
      <style>
        {`
          .sidebar-blog-card:hover img {
            filter: blur(2px) brightness(0.8); /* blur + dim image */
            transform: scale(1.03);
          }
          .sidebar-blog-card:hover .sidebar-blog-title {
            background: rgba(0,0,0,0.7); /* darker overlay */
            color: #fff; /* text fully visible */
            text-shadow: 2px 2px 6px rgba(0,0,0,0.9); /* stronger shadow */
          }
        `}
      </style>
    </div>
  );
};

export default MyLanding;
